import { render, staticRenderFns } from "./RoleTag.vue?vue&type=template&id=16996d8b&scoped=true&"
import script from "./RoleTag.vue?vue&type=script&lang=js&"
export * from "./RoleTag.vue?vue&type=script&lang=js&"
import style0 from "./RoleTag.vue?vue&type=style&index=0&id=16996d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16996d8b",
  null
  
)

export default component.exports